export const scrollSearchMatchIntoView = (container: HTMLElement, maximumAttempts = 60) => {
  let animationFrame = 0;
  let attempt = 0;

  const scrollWhenRendered = () => {
    const currentMatch = container.querySelector<HTMLElement>('[data-search-current="true"]');

    if (currentMatch) {
      currentMatch.scrollIntoView({ block: 'center' });
      return;
    }

    attempt++;
    if (attempt < maximumAttempts) {
      animationFrame = window.requestAnimationFrame(scrollWhenRendered);
    }
  };

  animationFrame = window.requestAnimationFrame(scrollWhenRendered);
  return () => window.cancelAnimationFrame(animationFrame);
};
